import { LocalizedField } from './LocalizedField'
export class UserData {
  constructor (params = {}) {
    this.userId = params.user_id ? params.user_id : null
    this.balance = params.balance ? params.balance : 0
    this.comission = params.commission ? params.commission : null
    this.refundableBalance = params.refundable_balance ? params.refundable_balance : null
    this.refundable = params.refundable || false
    this.noRefundMessage = params.no_refund_message ? new LocalizedField(params.no_refund_message) : null
  }
}
